<div class="map-popup-header d-flex flex-wrap">
    <div>
        <a [routerLink]="['/planera', arbetsorder.id]">{{ arbetsorder.namn }}</a>
        <rask-planeringsstatus-indicator
            class="statusCircle"
            [planeringsstatus]="arbetsorder['planeringsstatus']"></rask-planeringsstatus-indicator>
    </div>
    @if (arbetsorder.beteckning) {
    <div class="ms-1">{{arbetsorder.beteckning}}</div>
    }
    @if (arbetsorder.avverkningsgruppForkortning) {
    <div class="ms-1">{{arbetsorder.avverkningsgruppForkortning}}</div>
    }
</div>

<table class="map-popup-table">
    <tr>
        <td class="map-popup-table-header" translate="PLANERA_POPUP_VOLYM"></td>
        <td class="map-popup-table-header"
            translate="PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_SKORDAD">
        </td>
    </tr>
    <tr>
        <td>
            <span>{{ arbetsorder.volymArbetsorder | number }}</span>
            <span translate="PLANERA_ARBETSORDER_HEADER_M3FUB"></span>
        </td>
        <td>{{ arbetsorder['skordningAvslutadDatum']| date: 'yyyy-MM-dd' }}</td>
    </tr>
</table>
<table class="map-popup-table col-4">
    <tr>
        <td class="map-popup-table-header">
            @if (showAndelData) {
            <span>{{ 'PLANERA_ARBETSORDER_HEADER_TALL' | translate}}</span>
            }
        </td>
        <td class="map-popup-table-header">
            @if (showAndelData) {
            <span>{{ 'PLANERA_ARBETSORDER_HEADER_GRAN' | translate}}</span>
            }
        </td>
        <td class="map-popup-table-header">
            @if (showAndelData) {
            <span>{{ 'PLANERA_ARBETSORDER_HEADER_LOV' | translate}}</span>
            }
        </td>
        <td class="map-popup-table-header">
            @if (showAndelData) {
            <span>{{ 'PLANERA_ARBETSORDER_HEADER_CONTORTA' | translate}}</span>
            }
        </td>
    </tr>
    <tr>
        <td>{{ arbetsorder.andelTall | raskFordelning }}</td>
        <td>{{ arbetsorder.andelGran | raskFordelning }}</td>
        <td>{{ arbetsorder.andelLov | raskFordelning }}</td>
        <td>{{ arbetsorder.andelContorta | raskFordelning }}</td>
    </tr>
</table>

<div class="flex">

    <!-- Mark/Väg -->
    <table class="map-popup-table col-6">
        <tr>
            <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_TILLGANGLIGHET_SKOG"></td>
            <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_BILVAG"></td>
        </tr>
        <tr>
            <td>{{ arbetsorder.tillganglighetMark }}</td>
            <td>{{ arbetsorder.tillganglighetVag }}</td>
        </tr>
    </table>
    <!-- Planerad skotning -->
    <table class="map-popup-table col-6">
        <tr>
            <td class="map-popup-table-header" translate="PLANERA_POPUP_PLANERADSKOTNING"></td>
        </tr>
        @for (operation of operationer; track operation) {
        <tr>
            <td>{{ operation.startdatum| date: 'MMMM yyyy' }}</td>
        </tr>
        }
    </table>
</div>